module.exports = __webpack_public_path__ + "img/dzp_point.c0ef83e1.png";